import { useEffect } from 'react'
import { Config, Work, Exhibition } from '@prisma/client'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { getQuillPlaintext } from '../lib/quill'

type GuestHeadProps = {
  config?: Config
  work?: Work
  exhibition?: Exhibition
}

export const GuestHead: React.FC<GuestHeadProps> = ({ config, work, exhibition }) => {
  const siteTitle = config?.title ?? 'Captions and Audio'
  const description = config?.instructions ?? "Select an exhibition to view synchronized captions, or listen to a work's audio stream."
  let pageTitle = siteTitle
  if (work) {
    pageTitle = `${work ? getQuillPlaintext(work.title) : ''} - ${siteTitle}`
  } else if (exhibition) {
    pageTitle = `${exhibition ? exhibition.name : ''} - ${siteTitle}`
  }

  const router = useRouter()
  const gaId = config?.googleAnalyticsId

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      if (gaId && url) {
        window.gtag('config', gaId, {
          page_path: url,
        })
      }
    }
    router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router.events, gaId])

  return (
    <Head>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      {/* eslint-disable-next-line */}
      <link rel="stylesheet" href="/styles/guest-default.css" />
      {config?.guestStylesheetUrl && <link rel="stylesheet" href={config?.guestStylesheetUrl} />}
      {config?.faviconUrl && <link rel="icon" type="image/png" href={config?.faviconUrl} />}
      {
        gaId && (
          <>
            <script
              async
              src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
            />
            <script
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${gaId}', {
                  page_path: window.location.pathname,
                });
              `,
              }}
            />
          </>
        )
      }
    </Head>
  )
}
